import React from 'react'
import { Route } from 'react-router-dom'
import CLIENT_ENDPOINTS from '../../../constants/client-endpoints'
import ReflectionPromptScreen from '../screen'

const ReportRoutes = () => {
    return (
        <React.Fragment>
            <Route path={CLIENT_ENDPOINTS.REFLECTION_PROMPT} component={ReflectionPromptScreen} />
        </React.Fragment>
    )
}

export default ReportRoutes